import { useNavigate, useParams } from 'react-router-dom'; // Use navigate for programmatic navigation
import * as React from 'react';
import DouConfigPage from "./DouConfigPage";
import TokenPage from "./TokenPage";
import { Tabs } from "antd";
import CvConfigPage from "./CvConfigPage";
import DjinniConfigPage from "./DjinniConfigPage";

const JobConfigPage = () => {
    const { tabKey } = useParams(); // Get the tab key from the URL
    const navigate = useNavigate(); // For programmatic navigation

    const activeTab = tabKey || 'cv-config'; // Default to 'dou-config' if tabKey is not found

    const handleTabChange = (key) => {
        // When the tab changes, update the URL
        navigate(`/job-config/${key}`);
    };

    return (
        <Tabs
            activeKey={activeTab}  // Controlled active tab
            tabPosition="left"
            style={{ marginTop: '10px', height: '100vh' }}
            onChange={handleTabChange}  // Update URL when tab changes
            items={[
                {
                    key: 'cv-config',
                    label: '1. CV Config',
                    children: <CvConfigPage />,
                },
                {
                    key: 'dou-config',
                    label: '2. Dou Config',
                    children: <DouConfigPage />,
                },
                {
                    key: 'djinni-config',
                    label: '3. Djinni Config',
                    children: <DjinniConfigPage />,
                },
                /*{
                    key: 'token-config',
                    label: '4. Run',
                    children: <TokenPage />,
                },*/
            ]}
        />
    );
};

export default JobConfigPage;
